import { createFileRoute } from '@tanstack/react-router'
import { CreateJobPage } from '@/features/jobs/components/create-job-page'

export const Route = createFileRoute('/_app/_auth/dashboard/_layout/jobs/new')({
  component: CreateJobPage,
  beforeLoad: () => ({
    title: 'New Job',
    headerTitleKey: 'header.jobs.title',
    headerDescriptionKey: 'header.jobs.description',
  }),
})
